import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { Collapse } from 'reactstrap';
import { withLocalize } from 'react-localize-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { bindActionCreators } from 'redux';
import { Popover, PopoverBody } from 'reactstrap';
import { isNullOrUndefined, isFunction } from '../../../store/storeFunctions';
import { chartActions } from '../../../store/charts/chartsStore';
import BbCheckbox from '../../styling/bbCheckbox';

import '../chartSettings.scss';

class ChartSettingsButton extends React.Component {
    _noConflictPopover = undefined;

    constructor(props) {
        super(props);
        this.state = { displayPopover: false }
    };

    static propTypes = {
        id: PropTypes.string.isRequired,
        header: PropTypes.string,
        expanded: PropTypes.bool,
        expandable: PropTypes.bool,
        disabled: PropTypes.bool,
        popupButtonDisabled: PropTypes.bool,
        showChangeIndicator: PropTypes.bool,
        toggle: PropTypes.object,
        contentClasses: PropTypes.object,
        onExpand: PropTypes.func
    };

    static defaultProps = {
        header: undefined,
        expanded: true,
        expandable: true,
        disabled: false,
        popupButtonDisabled: true,
        showChangeIndicator: false,
        toggle: undefined,
        contentClasses: {},
        onExpand: (_) => { }
    };

    render() {
        const { id, disabled, showChangeIndicator, toggle, expandable, header, contentClasses, onExpand, expanded } = this.props;
        const toggleable = this.checkToggleability(toggle);
        const canExpand = !disabled && expandable;
        const hasHeader = !isNullOrUndefined(header);
        const popoverLabels = {
            text: this.props.translate("Charts.GraphReloadTooltip"),
            button: this.props.translate("Charts.UseFilter")
        };

        return (
            <div className={classnames("rc-box", { "disabled": disabled, "rc-no-header": !hasHeader })}>
                {hasHeader && <div className={classnames("rc-box-header", { "rc-interactive": canExpand })}
                    onClick={!toggleable && canExpand ? () => onExpand(!expanded) : undefined}
                >
                    {this.renderLabel(header, toggle, toggleable)}
                    <div className="rc-box-header-icons">
                        <div id={`rc-changed-${id}`} onMouseOver={() => this.toggle(true)}>
                            {showChangeIndicator && <FontAwesomeIcon icon="exclamation-triangle" className="rc-change-indicator" />}
                        </div>
                        {(canExpand || toggleable) && <div onClick={toggleable ? () => onExpand(!expanded) : undefined}>
                            <FontAwesomeIcon icon={expanded ? "angle-up" : "angle-down"} className="rc-expand-indicator" />
                        </div>}
                        {showChangeIndicator && <Popover onMouseLeave={() => this.hidePopover()} onMouseOver={() => this.keepPopoverVisible()}
                            placement="bottom" isOpen={this.state.displayPopover} toggle={this.toggle} target={`rc-changed-${id}`}
                        >
                            <PopoverBody>
                                <div className="rc-popover">
                                    <div>{popoverLabels.text}</div>
                                    <div>
                                        <button className={classnames("bb-button small gradient-1", { "is-square": localStorage.locales_button_style === "square" })}
                                            onClick={() => this.applyClicked()}
                                            disabled={this.props.popupButtonDisabled}
                                        >
                                            <span><FontAwesomeIcon icon="exclamation-triangle" /> <strong>{popoverLabels.button}</strong></span>
                                        </button>
                                    </div>
                                </div>
                            </PopoverBody>
                        </Popover>}
                    </div>
                </div>}
                <Collapse isOpen={canExpand ? expanded : true}>
                    <div className={classnames("rc-box-content", contentClasses)}>
                        {this.props.children}
                    </div>
                </Collapse>
            </div>
        );
    }

    componentDidMount() {
        this.props.onExpand(this.props.expanded && this.props.expandable);
    }

    renderLabel = (header, toggle, toggleable) => {
        return toggleable
            ? <div className="rc-checkbox rc-no-lpad"><BbCheckbox id={toggle.id} label={header} value={toggle.value} onChange={(v) => toggle.onChange(v)} /></div>
            : <span>{header}</span>;
    }

    checkToggleability = (toggle) => !isNullOrUndefined(toggle) && ["id", "value", "onChange"].every(k => Object.keys(toggle).includes(k)) && isFunction(toggle.onChange);

    toggle = (value) => {
        if (!isNullOrUndefined(value) && value === this.state.displayPopover)
            return;
        var isVisible = isNullOrUndefined(value) ? this.state.displayPopover : value;
        this.setState({ displayPopover: !this.state.displayPopover });
        if (!isVisible)
            this.autoHidePopover();
        else
            this.keepPopoverVisible();
    }

    handleScroll = () => {
        if (this.state.displayPopover) {
            this.setState({ displayPopover: false });
        }
    }

    autoHidePopover = () => {
        this._noConflictPopover = window.setTimeout(() => this.toggle(), 1500);
    }

    keepPopoverVisible = () => {
        if (this._noConflictPopover !== undefined && this._noConflictPopover !== null) {
            window.clearTimeout(this._noConflictPopover);
        }
    }

    hidePopover = () => {
        if (this._noConflictPopover !== undefined && this._noConflictPopover !== null) {
            window.clearTimeout(this._noConflictPopover);
            this._noConflictPopover = undefined;
        }
        window.setTimeout(() => this.toggle(), 500);
    }

    applyClicked = () => {
        if (this.props.onApplyFilter())
            this.toggle();
    }
}

export default withLocalize(connect(
    state => state.charts,
    dispatch => bindActionCreators(chartActions, dispatch)
)(ChartSettingsButton));